export function without<T, U extends T>(
  values: readonly U[],
  array: readonly T[]
) {
  return array.filter((value): value is U => !values.includes(value as U));
}
